import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { mobile, mobileM, tablet } from "../../responsive";

//
//
//
const WrapperHeaderProp = styled.div`
  padding: 70px 0 70px 0;
  width: 100%;
  height: auto;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${mobile({ padding: "0px 0 10px 0" })}
  ${mobileM({ padding: "10px 0 10px 0" })}
  ${tablet({ padding: "10px 0 10px 0" })};
`;
const ContainerHeaderProp = styled.div`
  width: 100%;
  padding: 0px 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  //
  ${mobile({ width: "100%", padding: "100px 0 50px 0" })}
  ${mobileM({ width: "100%" })}
  ${tablet({ width: "100%" })};
`;

const H1 = styled.h1`
  padding: 70px 0 0 0;
  font-weight: 600;
  font-size: 1.6em;
  font-family: "Poppins-Light";
  text-transform: Capitalize;
  letter-spacing: 3px;
  text-align: center;
  color: #272727f8;
`;
const H2 = styled.h1`
  padding: 0 0 40px 0;
  line-height: 20px;
  font-weight: 600;
  font-size: 0.9em;
  font-family: "Poppins-Light";
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;

  color: #272727e6;

  //
  //related to underline animation -----------

  position: relative;
  /* z-index: 4; */
  padding-bottom: 2px;
  //  underline animation

  &::after {
    content: "";
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 2.2px;

    bottom: 0;
    left: 0;
    background-color: #272727e6;
    transform-origin: bottom right;
    transition: transform 0.35s ease-out;
  }

  &:hover {
    &::after {
      transform: scaleX(1);
      transform-origin: bottom left;
    }
  }

  //
  //
  //
  ${mobile({
    lineHeight: "calc(11px + 1.4vmin)",
    fontSize: "calc(11px + 1.4vmin)",
  })}
`;

//

const PropHeaderSections = ({
  TitlePropHeaderSection,
  SubTitlePropHeaderSection,
}) => {
  return (
    <>
      <WrapperHeaderProp>
        <ContainerHeaderProp>
          <H1>{TitlePropHeaderSection}</H1>
          <H2 type="button">{SubTitlePropHeaderSection}</H2>
        </ContainerHeaderProp>
      </WrapperHeaderProp>
    </>
  );
};

export default PropHeaderSections;
